import { FC } from "react";
import { AdminEmailTemplates } from "../../../modules/admin/components/screens/admin-email-templates/admin-email-templates";

export const AdminEmailTemplatesRoute: FC = () => {
    return (
        <AdminEmailTemplates />
    )
}